<div class="search-container">
  <input #addressInput 
         type="text" 
         [(ngModel)]="searchQuery"
         (input)="onSearchChange($event)"
         placeholder="Ingresa una dirección" 
         class="address-input">

  <div *ngIf="predictions.length" class="predictions-dropdown">
    <div *ngFor="let prediction of predictions" 
         class="prediction-item"
         (click)="selectPrediction(prediction)">
      {{ prediction.description }}
    </div>
  </div>

  <div *ngIf="placePhotoUrl" class="photo-container">
    <img [src]="placePhotoUrl" alt="Foto del lugar" class="place-photo">
  </div>
</div>